export const CONFIG = {
    client_name : "hoval",
    client_display_name : "Hoval",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : ` https://esr.fe-bis.de/de/hoval/`,
    plz_validation : (plz : string) => plz.length == 5,
    foerderung : true
}